module.exports = __webpack_public_path__ + "static/arthur-app-soda-1049316781d23e501e6c171dd4c1ce07.gif";